import { useTranslation } from 'react-i18next';

import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import style from './SectionDelete.module.scss';
import React from 'react';
import {
  Badge,
  ButtonPrimary,
  Loader,
  ModalContent,
  ModalHeader,
} from '@skf/bt-wind-rail-commonlibrary';
import { SectionTable } from '../../../../store/sections/types';
import { useToast } from '../../../../hooks/useToast';
import { ISectionsState } from '../../../../store/sections/store';
import { StoreState } from '../../../../store/store';
import { isValidResponse } from '../../../../services/responseService';
import {
  deleteSection,
  fetchSectionsAction,
} from '../../../../store/sections/actions';
import { FullscreenModal } from '../../../common/fullscreenModal/FullscreenModal';

interface ISectionDeleteProps {
  section?: SectionTable;
  onClose: () => void;
}

export const SectionDelete: React.FunctionComponent<ISectionDeleteProps> = ({
  section,
  onClose,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { addToast } = useToast();

  const { message, status, loading, commited }: ISectionsState = useSelector<
    StoreState,
    ISectionsState
  >((state) => state.sections);

  const onClickClose = () => !loading && onClose();

  useEffect(() => {
    const _isValidResponse = isValidResponse(status);
    if (loading == false && _isValidResponse) {
      if (commited) {
        if (message != undefined && message !== '') {
          addToast({
            status: 'warning',
            message: message,
          });
        } else {
          addToast({
            status: 'ok',
            message: t('Section_successfully_deleted'),
          });
        }
        dispatch(fetchSectionsAction());
      } else {
        addToast({
          status: 'danger',
          message: message || `Error ${status}`,
        });
      }
      onClose();
    }
  }, [message, status]);

  const onClickSubmit = () => {
    dispatch(
      deleteSection(
        section?.industry,
        section?.portalName,
        section?.webSectionName
      )
    );
  };

  return (
    <FullscreenModal onClose={onClickClose} className={style.modal}>
      <ModalHeader onClose={onClickClose}>{t('Delete_Section')}</ModalHeader>
      <ModalContent className={style.content}>
        <>
          <Loader center show={loading} className={style.loader} />
          <div className={loading ? style.blur : ''}>
            <div className={style.container}>
              {t('You_are_trying_to_delete')}
              <Badge className={style.badge}>
                {section?.webSectionName}
              </Badge>, {t('are_you_sure')}?
            </div>
            <div className={style.navigation}>
              <ButtonPrimary onClick={onClickClose} outline>
                {t('Cancel')}
              </ButtonPrimary>
              <ButtonPrimary onClick={onClickSubmit}>{t('Ok')}</ButtonPrimary>
            </div>
          </div>
        </>
      </ModalContent>
    </FullscreenModal>
  );
};
